import React, { Component } from 'react';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';

import {Dropdown} from 'primereact/dropdown';
import {Button} from 'primereact/button';
export class Search extends Component {
    state = {
        display : true,
        departmentList : [
            {
                label: '---Select Concerned Department---',
                value : null
            },
            {
                label: 'IT',
                value : 'IT'
            },
            {
                label: 'Finance Mangement',
                value : 'Finance Mangement'
            }
        ],
        dataTableValue: [{
            incidentno : "I-201908-00002",
            incidentdesc : "OIL SPILL",
            date : "02/08/2019",
            cratedby : "George Varghese",
            status : "RAISED",
            action : "OIL SPILL",
            pendingwith : "Sami Ullah Abbasi"
        },{
            incidentno : "I-201908-00002",
            incidentdesc : "OIL SPILL",
            date : "02/08/2019",
            cratedby : "George Varghese",
            status : "RAISED",
            action : "OIL SPILL",
            pendingwith : "Sami Ullah Abbasi"
        },{
            incidentno : "I-201908-00002",
            incidentdesc : "OIL SPILL",
            date : "02/08/2019",
            cratedby : "George Varghese",
            status : "RAISED",
            action : "OIL SPILL",
            pendingwith : "Sami Ullah Abbasi"
        },{
            incidentno : "I-201908-00002",
            incidentdesc : "OIL SPILL",
            date : "02/08/2019",
            cratedby : "George Varghese",
            status : "RAISED",
            action : "OIL SPILL",
            pendingwith : "Sami Ullah Abbasi"
        },{
            incidentno : "I-201908-00002",
            incidentdesc : "OIL SPILL",
            date : "02/08/2019",
            cratedby : "George Varghese",
            status : "RAISED",
            action : "OIL SPILL",
            pendingwith : "Sami Ullah Abbasi"
        },{
            incidentno : "I-201908-00002",
            incidentdesc : "OIL SPILL",
            date : "02/08/2019",
            cratedby : "George Varghese",
            status : "RAISED",
            action : "OIL SPILL",
            pendingwith : "Sami Ullah Abbasi"
        },{
            incidentno : "I-201908-00002",
            incidentdesc : "OIL SPILL",
            date : "02/08/2019",
            cratedby : "George Varghese",
            status : "RAISED",
            action : "OIL SPILL",
            pendingwith : "Sami Ullah Abbasi"
        },{
            incidentno : "I-201908-00002",
            incidentdesc : "OIL SPILL",
            date : "02/08/2019",
            cratedby : "George Varghese",
            status : "RAISED",
            action : "OIL SPILL",
            pendingwith : "Sami Ullah Abbasi"
        },{
            incidentno : "I-201908-00002",
            incidentdesc : "OIL SPILL",
            date : "02/08/2019",
            cratedby : "George Varghese",
            status : "RAISED",
            action : "OIL SPILL",
            pendingwith : "Sami Ullah Abbasi"
        },{
            incidentno : "I-201908-00002",
            incidentdesc : "OIL SPILL",
            date : "02/08/2019",
            cratedby : "George Varghese",
            status : "RAISED",
            action : "OIL SPILL",
            pendingwith : "Sami Ullah Abbasi"
        },{
            incidentno : "I-201908-00002",
            incidentdesc : "OIL SPILL",
            date : "02/08/2019",
            cratedby : "George Varghese",
            status : "RAISED",
            action : "OIL SPILL",
            pendingwith : "Sami Ullah Abbasi"
        },{
            incidentno : "I-201908-00002",
            incidentdesc : "OIL SPILL",
            date : "02/08/2019",
            cratedby : "George Varghese",
            status : "RAISED",
            action : "OIL SPILL",
            pendingwith : "Sami Ullah Abbasi"
        },{
            incidentno : "I-201908-00002",
            incidentdesc : "OIL SPILL",
            date : "02/08/2019",
            cratedby : "George Varghese",
            status : "RAISED",
            action : "OIL SPILL",
            pendingwith : "Sami Ullah Abbasi"
        },{
            incidentno : "I-201908-00002",
            incidentdesc : "OIL SPILL",
            date : "02/08/2019",
            cratedby : "George Varghese",
            status : "RAISED",
            action : "OIL SPILL",
            pendingwith : "Sami Ullah Abbasi"
        }]
    }


    	


  
    render() {   
        return (
            <div className="p-grid search">
               <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Request Search</h1>
               
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6 p-lg-5">
                                <div className="mt1">
                                    <InputText className="p-col-12" name="keyword" placeholder="Enter Keyword"/>
                                </div>   
                            </div>
                            
                            <div className="p-col-12 p-md-6 p-lg-5">
                                <div className="mt1">

                                <Dropdown className="p-col-12" placeholder="Concerned Department" options={this.state.departmentList} name="department" value={this.state.department} onChange={event => this.setState({department: event.value})} />


                                </div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-2">
                                <div className="mt1">
                                <Button style={{float: 'left'}} label="Search" icon="pi pi-search"  />
                                </div>                               
                            </div> 
                      
                            					 	
                        <div className="p-col-12" style={{marginTop:'2em'}}>
                            
                            <DataTable value={this.state.dataTableValue} selectionMode="single" header="Search Results">
                                <Column field="incidentno" header="INCIDENT NO" sortable={true} />
                                <Column field="incidentdesc" header="INCIDENT DESCRIPTION" sortable={true} />
                                <Column field="date" header="INCIDENT DATE" sortable={true} />
                                <Column field="cratedby" header="CREATED BY" sortable={true} />
                                <Column field="status" header="STATUS" sortable={true} />
                                <Column field="action" header="CORRECTIVE ACTION TAKEN" sortable={true} />
                                <Column field="pendingwith" header="PENDING WITH" sortable={true} />
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}